import React from "react";
import AuthLayout from "../Layout/AuthLayout";
import NonAuthLayout from "../Layout/NonAuthLayout";
import { Redirect, Route, useLocation } from "react-router-dom";
import { getFromStorage } from "utils/storage";
import { getUserType } from "store/userType";

const Authmiddleware = ({
  path,
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => {
  const location = useLocation();
  const isUserType = getUserType((state) => state.isUserType);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthProtected && !getFromStorage("user_data")) {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        } 
        // else if (!isAuthProtected) {
        //   return (
        //     <Redirect
        //       to={{
        //         pathname:path,
        //         state: { from: props.location },
        //       }}
        //     />
        //   );
        // }

        return (
          <>
            {location.pathname === "/login" ||
            location.pathname === "/login-otp" ||
            location.pathname === "/forgot-password" ||
            location.pathname === "/sign-up" ||
            location.pathname === "/unlock-account" ||
            location.pathname === "/register-success" ||
            location.pathname === "/reset-password" ||
            location.pathname === "/payment-success"  ? (
              // location.pathname === "/confirmation-receipt" ||
              // location.pathname === "/booking-form"
              <NonAuthLayout>
                <Component />
              </NonAuthLayout>
            ) : (
              <AuthLayout>
                <Component {...props} />
              </AuthLayout>
            )}
          </>
        );
      }}
    />
  );
};

export default Authmiddleware;
